import { Button, Column, Form, Grid, Row, Tile, FileUploaderDropContainer } from "carbon-components-react";
import { useState, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Padding from "../../components/Padding";
import UIShell from "../../components/UIShell";
import { updateCategoryImage } from "../../redux/actions/categoryAction";
import { useDropzone } from 'react-dropzone';

import "./Categories.scss";

function CategoryImagePage({ isLoading }) {
    const history = useHistory()
    const dispatch = useDispatch()
    const location = useLocation();

    const categoryId = location.pathname.split("/")[2];
    
    const imageInstance = useRef(null)

    const [formContent, setFormContent] = useState({
        categoryId,
        thumbnail: undefined
    })

    const submitForm = (e) => {
        e.preventDefault()

        dispatch(updateCategoryImage(formContent, (_data) => {
            history.push("/categories")
        }))
    }

    const onDrop = (acceptedFiles) => {
      const selectedFile = acceptedFiles[0];
      const reader = new FileReader();

      reader.onload = (event) => {
        imageInstance.current.src = event.target.result;
      };

      reader.readAsDataURL(selectedFile);
      setFormContent((data) => ({
        ...data,
        thumbnail: selectedFile,
      }));
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      accept: ['image/jpeg', 'image/png'],
      multiple: false,
      onDrop,
    });

    return (
        <UIShell breadcrumbs={[
            { name: 'Home', link: "/" },
            { name: 'Categories', link: "/categories" },
            { name: 'Image' }
        ]}>
          <Grid>
            <Row>
              <Column>
                <Tile>
                  <Form onSubmit={submitForm}>
                    <div {...getRootProps()} className={`cds--file-container ${isDragActive ? 'cds--file-container--drop' : ''}`}>
                      <input {...getInputProps()} />
                      <div className="drop-container">
                        {isDragActive ? (
                            <p>Drop the files here...</p>
                        ) : (
                            <p>Drag and drop files here or click to upload</p>
                        )}
                      </div>
                    </div>
     
                    {formContent.thumbnail && (
                      <img
                        ref={imageInstance}
                        style={{
                          width: 400,
                          margin: '20px 0 0 0',
                          borderRadius: 5,
                        }}
                      />
                    )}
                    <Padding top="1rem">
                      <Button disabled={isLoading} type="submit" kind="primary">
                        Save
                      </Button>
                      <Button onClick={() => history.push("/categories")} kind="secondary">
                        Cancel
                      </Button>
                    </Padding>
                  </Form>
                </Tile>
              </Column>
            </Row>
          </Grid>
        </UIShell>
    )
}

const mapStateToProps = state => {
    return {
        isLoading: state.uxReducer.isLoading
    }
}

export default connect(mapStateToProps)(CategoryImagePage)